export enum GoalFormParam {
	Category = "category",
	Name = "name",
	TotalValue = "totalValue",
	OwnFunds = "ownFunds",
	LoanAmount = "loanAmount",
	MonthlyRent = "monthlyRent",
	StatePension = "statePension",
	RentYears = "rentYears",
	DrawdownMode = "drawdownMode",
	DueDate = "dueDate",
	InspirationType = "inspirationType",
}
